import React, { useContext } from 'react';
import { Form, Input, Button, Layout, Row, Col,InputNumber } from 'antd';
import { BrowserRouter as Router, useHistory } from 'react-router-dom';
import { authenticationService } from '../../services';
import "./Register.css";
import AppHeading from '../../components/AppHeading';
import { GlobalContext } from '../../contexts/GlobalContext';
const { Header, Footer, Sider, Content } = Layout;

const Register = (props) => {
  const { errorHandler, successHandler } = useContext(GlobalContext);
  const history = useHistory()

  if (authenticationService.currentUserValue && authenticationService.currentUserValue.name) {
    if (!props.location.state) {
      props.history.push('/app/entity');
    }
    else {
      history.push(`${props.location.state.from.pathname}`);
    }
  }

  const onFinish = async (credentials) => {
    var details = {
        subjectName: credentials.subjectName,
        subjectOIB: credentials.subjectOIB,
        subjectAddress: credentials.subjectAddress
    }
    credentials['details'] = details
    delete credentials.subjectName
    delete credentials.subjectOIB
    delete credentials.subjectAddress
    if (credentials.password !== credentials.confirmPassword) {
      errorHandler("Lozinke se ne podudaraju")
    }
    else {
      try {
        delete credentials.confirmPassword
        const trimmedCredentials={name:credentials.name,surname:credentials.surname,email:credentials.email.trim(),password:credentials.password.trim(),details:credentials.details}
        const user = await authenticationService.register(trimmedCredentials);
        console.debug("Got response registration:", user)

        if (user && user.name.length) {
          successHandler("Uspješno ste se registrirali u sustav!")
          props.history.push('/app/entity');
        }
        else {
          errorHandler("Neuspješna registracija! Molimo pokušajte ponovno kasnije.")
        }
      }
      catch (error) {
        console.error('Failed registration:', error)
        errorHandler("Pogreška prilikom registracije u sustav!")
      }
    }
  };

  const onFinishFailed = errorInfo => {
    console.error('Finish failed registration:', errorInfo)
    errorHandler("Pogreška prilikom registracije u sustav!")

  };


  return (
    <div>
      <Layout>
        <AppHeading dark={true}></AppHeading>
        <Content className="register__content">
          <div className="white-box-register">
            <h1 className='register__title'>Registracija za institucije i gospodarske subjekte</h1>
            <Form
              name="register"
              className="register-form"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                name="subjectName"
                rules={[
                  {
                    required: true,
                    message: 'Molimo unesite naziv pravne osobe!',
                  },
                ]}
              >
                <Input placeholder="Naziv pravne osobe" />
              </Form.Item>
              <Form.Item
                name="subjectOIB"
                rules={[
                  {
                    required: true,
                    message: 'Molimo unesite OIB!',
                  },                  
                ]}
              >
                <InputNumber placeholder="OIB pravne osobe" />
              </Form.Item>
              <Form.Item
                name="subjectAddress"
                rules={[
                  {
                    required: true,
                    message: 'Molimo unesite adresu pravne osobe!',
                  },
                ]}
              >
                <Input placeholder="Adresa pravne osobe" />
              </Form.Item>
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    
                    message: 'Molimo unesite ime predstavnika!',
                  },
                ]}
              >
                <Input placeholder="Ime predstavnika" />
              </Form.Item>
              <Form.Item
                name="surname"
                rules={[
                  {
                    required: true,
                    
                    message: 'Molimo unesite prezime predstavnika!',
                  },
                ]}
              >
                <Input placeholder="Prezime predstavnika" />
              </Form.Item>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,                    
                    message: 'Molimo unesite Vaš e-mail!',
                  },
                  {
                    type: 'email',  
                    message: 'Trenutno uneseni e-mail nije pravilan'    
                  },
                ]}
              >
                <Input placeholder="E-mail" />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Molimo unesite lozinku!',
                  },
                  { min: 6, message: 'Lozinka mora imati minimalno 6 znamenaka.' }
                ]}
              >
                <Input.Password placeholder="Lozinka" />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                rules={[
                  {
                    required: true,
                    message: 'Lozinke se ne podudaraju!',
                  },
                ]}
              >
                <Input.Password placeholder="Potvrda lozinke" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" className="register-form-button">
                  Registriraj se
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Content>
      </Layout>

    </div>
  );

}

export default Register;
